export default {
  items: [],
  pagination: {},
  isBusy: false,
  filter: {},
  size: 15,
  form: {},
};
